import Vue from 'vue'

import AppLayout from './layout/index.vue'
// import router from './router'
// import store from './store'
import './scss/style.scss'
import './assets/fonts/bebasneue.css'
import VueLazyload from 'vue-lazyload'
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/assets/images/placeholder.png',
  loading: '/assets/images/placeholder.png',
  attempt: 1
})
Vue.config.productionTip = false

new Vue({
  name: 'Root',
  render: h => h(AppLayout)
}).$mount('#vue-app')
